import { render } from "./Foyer.vue?vue&type=template&id=6e785e74&scoped=true&ts=true&lang=html"
import script from "./Foyer.vue?vue&type=script&lang=ts"
export * from "./Foyer.vue?vue&type=script&lang=ts"

import "./Foyer.vue?vue&type=style&index=0&id=6e785e74&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e785e74"]])

export default __exports__